import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { ShiftsForm } from '@modules/hr-shifts/ShiftsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const shiftsUrl = '/metropolis/api/hr/workplan/shift';
export const shiftsLabel = 'Personalistika - směny';
export const shiftsPath = '/hr/shifts/shifts';
export const shiftsGridName = 'ShiftsGrid';
export const ShiftsGrid = compose(
  withRouter,
  setDisplayName(shiftsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: shiftsLabel }]),
  withColumns(Agenda.SHIFTS),
  withProps(({ columns }) => ({
    name: shiftsGridName,
    url: shiftsUrl,
    Form: ShiftsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.SHIFTS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-shifts/ShiftsGrid.tsx